import { useEffect, useReducer, useRef, useState } from "react";
import { useParams } from "react-router";
import { getInitialTabularState, reducer } from "../../shared/reporting/components/viewer/storage/runState";
import { updateDataSet } from "../api/dataSetApiContext";
import { useEnhancedBiApiClientProvider } from "../contexts/ApiClientProviderContext";
import { useAppDispatch } from "../store/hooks/useAppDispatch";
import { setViewReport } from "../store/thunks/currentReportThunks";
import { createCurrentReportAction } from "../store/utils/storeUtils";
import { getExistingReportWithAuth, manageReportSwitching } from "../utilities/defineReportDataHelper";

const useDefineViewReportData = () => {
  const { id } = useParams();
  const { getReport, getReportAuthorizationInfo, getReportConfigurationForRunning } = useEnhancedBiApiClientProvider();
  const dispatch = useAppDispatch();
  const [showReportNotFound, setShowReportNotFound] = useState(false);
  const [isSwitchingReport, setShowSwitchingReport] = useState(false);
  const cachedReportId = useRef<string | undefined>(undefined);
  const [isFetching, setIsFetching] = useState(false);
  const [runState, dispatchRunState] = useReducer(reducer, getInitialTabularState());

  useEffect(() => {
    const isSwitchingReport = !!cachedReportId.current && cachedReportId.current !== id;
    cachedReportId.current = id;

    const execute = async () => {
      if (id !== undefined) {
        setIsFetching(true);
        await getExistingReportWithAuth(
          getReport.bind(null, id, "run"),
          getReportConfigurationForRunning.bind(null, id),
          getReportAuthorizationInfo.bind(null, id),
          () => setShowReportNotFound(true),
          (report, runningData) => {
            updateDataSet(runningData.dataSetId);
            dispatch(setViewReport({ ...report, dataSetId: runningData.dataSetId }));
            dispatchRunState({
              type: "Initialize",
              payload: { response: { ...runningData }, reportId: id },
            });
          },
          (authorizationInfo) => dispatch(createCurrentReportAction("setAuthorizationInfo", authorizationInfo))
        );
        setIsFetching(false);
      }
    };
    manageReportSwitching(isSwitchingReport, setShowSwitchingReport, execute);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return { showReportNotFound, isSwitchingReport, isFetching, runState, dispatchRunState };
};

export default useDefineViewReportData;
